module.exports = __webpack_public_path__ + "common/icon-gmail-5a995a20f1baef6939dab3dc46a0d5b3.png";